import * as yup from 'yup';

export const getOidcSchema = i18n => {
  const mandatory = 'identification_admin.add_service.mandatoryField';
  const missing = i18n('identification_admin.add_service.missingValue');
  const invalidUrl = 'identification_admin.add_service.invalidUrl';
  const invalidEmail = 'identification_admin.add_service.invalidEmail';
  const insufficientLength =
    'identification_admin.add_service.insufficientLength';
  return yup.object().shape({
    env: yup.string().required(i18n(mandatory)),
    vtj_verification_required: yup.string().required(missing),
    service_name_fi: yup
      .string()
      .min(3, insufficientLength)
      .required('identification_admin.add_service.mandatoryField'),
    service_name_sv: yup
      .string()
      .min(3, insufficientLength)
      .required(mandatory),
    service_name_en: yup
      .string()
      .min(3, insufficientLength)
      .required(mandatory),
    service_name_sms: yup.string().required(mandatory),
    service_name_smn: yup.string().required(mandatory),
    service_name_sme: yup.string().required(mandatory),
    service_login_page: yup
      .string()
      .url(invalidUrl)
      .min(1, insufficientLength)
      .required(mandatory),
    privacy_statement_url: yup
      .string()
      .url(invalidUrl)
      .min(1, mandatory)
      .required(mandatory),
    response_types: yup
      .array()
      .of(yup.string().trim())
      .min(1)
      .required(missing),
    contact_person_emails: yup
      .array()
      .of(
        yup
          .string()
          .trim()
          .email(invalidEmail)
          .required(mandatory)
      )
      .min(1, mandatory)
      .required(mandatory),
    client_id: yup.string().required(mandatory),
    default_acr_values: yup
      .array()
      .of(
        yup
          .string()
          .trim()
          .min(1)
          .required(i18n(mandatory))
      )
      .min(1, i18n(mandatory))
      .required(i18n(mandatory)),
    scope: yup.string().required(missing),
    jwks_uri: yup
      .string()
      .url(invalidUrl)
      .required(mandatory),
    redirect_uris: yup
      .array()
      .of(
        yup
          .string()
          .trim()
          .min(1, mandatory)
          .url(invalidUrl)
          .required(mandatory)
      )
      .min(1, mandatory)
      .required(mandatory),
    post_logout_redirect_uris: yup
      .array()
      .of(
        yup
          .string()
          .trim()
          .min(1, insufficientLength)
          .url(invalidUrl)
          .required(mandatory)
      )
      .min(1, mandatory)
      .required(mandatory),
    frontchannel_logout_uri: yup
      .string()
      .url(invalidUrl)
      .required(mandatory),
    frontchannel_logout_session_required: yup.string().required(missing),
    grant_types: yup
      .array()
      .of(
        yup
          .string()
          .trim()
          .min(1)
          .required(mandatory)
      )
      .min(1)
      .required(missing),
    id_token_encrypted_response_alg: yup.string().required(missing),
    id_token_encrypted_response_enc: yup.string().required(missing),
    id_token_signed_response_alg: yup.string().required(missing),
    token_endpoint_auth_method: yup.string().required(missing),
    journal_number: yup
      .string()
      .notRequired()
      .nullable()
      .when('no_decision', {
        is: true,
        then: yup
          .string()
          .required(mandatory)
          .nullable()
      }),
    approved_date: yup
      .date()
      .notRequired()
      .when('no_decision', {
        is: true,
        then: yup.date().required(mandatory)
      }),
    decision_id: yup
      .string()
      .notRequired()
      .nullable()
      .when(['env', 'no_decision'], {
        is: (env, no_decision) => env === 'production' && no_decision !== true,
        then: yup
          .string()
          .required(missing)
          .nullable()
      })
  });
};
